import { FC, useState } from 'react';
import {
  Button,
  ButtonSize,
  ButtonStyles,
  Modal,
  Theme,
  useTranslation,
  ButtonWidth,
} from '@nextgen-web-framework/all';
import { ConfigService, ApiConfigService } from '@nextgen-web-framework/core';
import { LoginButton } from '@commerce-identity-webcomponents/ui';
import styles from './LoginRedirectModel.module.scss';
import { LoginRedirectModelProps } from './types/propsTypes';

const LoginRedirectModel: FC<LoginRedirectModelProps> = ({ setIsVisibleModal }) => {
  const [onClose, setOnClose] = useState(true);

  const onTextModalClose = () => {
    setOnClose(false);
    setIsVisibleModal(false);
  };
  const t = useTranslation();

  const getLoginProps = () => {
    const tuples = ApiConfigService.getTuples();
    let postAuthUrl = '';
    if (typeof window !== 'undefined') {
      postAuthUrl = btoa(JSON.stringify({ redirectUri: window.location.href, headers: tuples }));
    }
    const configs = ConfigService.getConfigs();
    return {
      scope: 'openid',
      state: postAuthUrl,
      countryIso: tuples['X-Amway-Country'],
      redirectUri: configs.NEXT_PUBLIC_OIDC_URL ? `${configs.NEXT_PUBLIC_OIDC_URL}` : '',
    };
  };

  return (
    <div className={styles['have-an-modal-container']} data-testid="have-an-modal-container-id">
      {onClose && (
        <Modal
          headline={t('subscription.redirectSignInModel.title')}
          primaryButtonLabel={''}
          onClose={onTextModalClose}
          useReactPortal={true}
          portalContainerId="react-portal-modal"
        >
          <>
            <span className={styles['have-an-modal-description']}>
              {t('subscription.redirectSignInModel.subTitle')}
            </span>
            <div className={styles['merge-cart-button-container']}>
              <LoginButton
                theme={Theme.BLACK}
                buttonStyle={ButtonStyles.SOLID}
                size={ButtonSize.MEDIUM}
                title={t('subscription.redirectSignInModel.signIn.text')}
                buttonWidth={ButtonWidth.FULL_WIDTH}
                {...getLoginProps()}
              />
              <Button
                title={t('subscription.redirectSignInModel.cancel.text')}
                buttonStyle={ButtonStyles.OUTLINE}
                theme={Theme.BLACK}
                size={ButtonSize.MEDIUM}
                buttonWidth={ButtonWidth.FULL_WIDTH}
                data-testid="cancel-login-testid"
                onClick={onTextModalClose}
              />
            </div>
          </>
        </Modal>
      )}
    </div>
  );
};

export default LoginRedirectModel;
